import { Button, DataSource, Layout, LayoutHeader, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutReplaceSalespersonOpsUser extends Layout {
    buttonExecute: Button;
    layoutheaderReplaceSalespersonOpsUser: LayoutHeader;
    panelSearch: Panel;
    sourceReplaceUser: DataSource;
    tableUpdates: Table;
    textboxExisting: Textbox;
    textboxReplace: Textbox;
    textboxReplaceWith: Textbox;
}
